import React from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from '@mui/material';

export default function MockRequisitionFormDialog({ open, onClose, orderLabel }) {
  const requisitionUrl = '/mock-requisition-form.pdf';
  const handleDialogClose = (_, reason) => {
    if (reason === 'backdropClick') {
      return;
    }
    onClose();
  };
  const handleOpenInTab = () => {
    window.open(requisitionUrl, '_blank', 'noopener,noreferrer');
    onClose();
  };
  const handlePrint = () => {
    const printWindow = window.open(requisitionUrl, '_blank', 'noopener,noreferrer');
    if (printWindow) {
      const triggerPrint = () => {
        try {
          printWindow.focus();
          printWindow.print();
        } catch (error) {
          console.error('Failed to print requisition form:', error);
        }
      };
      setTimeout(triggerPrint, 500);
    }
    onClose();
  };

  return (
    <Dialog open={open} onClose={handleDialogClose} maxWidth="sm" fullWidth>
      <DialogTitle>Requisition Form</DialogTitle>
      <DialogContent dividers>
        <Typography variant="body1" sx={{ mb: 1 }}>
          {orderLabel ? `Order ${orderLabel} was created.` : 'The order was created.'}
        </Typography>
        <Typography variant="body2" color="text.secondary">
          What would you like to do with the requisition form?
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Not Now</Button>
        <Button variant="outlined" onClick={handlePrint}>Print</Button>
        <Button variant="contained" onClick={handleOpenInTab}>Open in Tab</Button>
      </DialogActions>
    </Dialog>
  );
}
